import { Grid } from '@mui/material';

import { MEDICAL_SELECTION_OPTIONS } from '../constants';
import MedicalSelectionGroup from './MedicalSelectionGroup';

import type { MedicalSelectionSectionsProps } from './types';

export default function MedicalSelectionSections(props: MedicalSelectionSectionsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <MedicalSelectionGroup {...props}
          label="Early Childhood Intervention (ECI)"
          addButtonLabel="Add intervention"
          placeholder="Select intervention"
          selectionType="EARLY_INTERVENTION"
          values={MEDICAL_SELECTION_OPTIONS.EARLY_INTERVENTION}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MedicalSelectionGroup {...props}
          label="Issues during pregnancy or birth"
          addButtonLabel="Add issue"
          placeholder="Select issue"
          selectionType="PREGNANCY_ISSUE"
          values={MEDICAL_SELECTION_OPTIONS.PREGNANCY_ISSUE}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MedicalSelectionGroup {...props}
          label="Any regression in the areas of"
          addButtonLabel="Add regression"
          placeholder="Select regression"
          selectionType="REGRESSION"
          values={MEDICAL_SELECTION_OPTIONS.REGRESSION}
        />
      </Grid>
    </Grid>
  );
}
